import { Component, OnInit, ViewChild } from '@angular/core';
import { NgbModal, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'recaptcha-popup',
  templateUrl: './recaptcha-popup.component.html',
  styleUrls: ['./recaptcha-popup.component.scss']
})
export class RecaptchaPopupComponent implements OnInit {

  constructor(private ngbModal: NgbModal, private activeModal: NgbActiveModal) { }

  ngOnInit() {

  }

  onCaptchaResolved(isResolved: string) {
    if (isResolved) {
      setTimeout(() => {
        this.activeModal.close(true);
      }, 10);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/captcha/components/recaptcha-popup.component.ts